import * as React from 'react'

function SvgVc(props) {
	return (
		<svg viewBox="0 0 72 48" width="1em" height="1em" {...props}>
			<path fill="#009e60" d="M0 0h72v48H0z" />
			<path fill="#fcd116" d="M0 0h54v48H0z" />
			<path fill="#0072c6" d="M0 0h18v48H0z" />
			<g fill="#009e60">
				<path d="M32 34l4 8 4-8-4-8zM27 24l4 8 4-8-4-8zM37 24l4 8 4-8-4-8z" />
			</g>
		</svg>
	)
}

export default SvgVc
